<template>
  <header>
    <UserSearch/>
    <Title/>
  </header>
  <Groups/>
  <Calendar/>
  <Config/>
  <ul class="legenda">
    <li class="icon icon-home">Thuis</li>
    <li class="icon icon-open">Openen</li>
    <li class="icon icon-office">Kantoor (Middelharnis)</li>
    <li class="icon icon-skyscraper">Kantoor Rotterdam</li>
    <li class="icon icon-extern">Extern</li>
    <li class="icon icon-servicedesk">Servicedesk</li>
    <li class="icon icon-rosterfree">Roostervrije dag</li>
    <li class="icon icon-free">Vrije dag</li>
    <li class="icon icon-holiday">Vakantie</li>
  </ul>
</template>

<script>
import Calendar from './components/Calendar.vue'
import Config from './components/Config.vue'
import Groups from './components/Groups.vue'
import Title from './components/Title.vue'
import UserSearch from './components/UserSearch.vue'

export default {
  name: 'App',
  async beforeCreate() {
    await this.$store.commit('initialiseStore')
    this.$store.dispatch('initClient')
    await this.$store.dispatch('calculateDateWindow')
    await this.$store.dispatch('loadGroups')
    await this.$store.dispatch('loadSchedule')
  },
  components: {
    Calendar,
    Config,
    Groups,
    Title,
    UserSearch
  }
}
</script>

<style>
:root {
  --font-family: 'CeraPRO', sans-serif;
/* Font sizes */
  --font-size-xxs: 1.2rem;
  --line-height-xxs: 1.3rem;

  --font-size-xs: 1.5rem;
  --line-height-xs: 3rem;

  --font-size-sm: 1.8rem;
  --line-height-sm: 3rem;

 /* Default colors */
  --color-default:             #16002B; /* very dark purple/gray, almost black */
  --color-default-light:       #90889B; /* lighter purple/gray */
  --color-default-lighter:     #B9B2BF; /* lighter purple/gray */
  --color-default-ondark:      #ffffff; /* white */
  --color-default-background:  #ffffff; /* white */
  --color-secondary-background:#EFEDF0; /* grey */
/* Brand colors */
  --color-brand-1st:           #00E9D7; /* greenish */
  --color-brand-1st-dark:      #20CDC0; /* light greenish */
  --color-brand-2nd:           #339AFA; /* blue 339AFA - 3599FA */
  --color-brand-2nd-light:     #17C5E7; /* light-blue */
  --color-brand-3rd:           #16002B; /* purple */
  --color-brand-3rd-light:     #20003E; /* light purple */
  --color-brand-3rd-lighter:   #8D8099; /* lighter purple */

/* Action colors */
  --color-error:               #fa5433; /* green */
  --color-valid:               #20CDC0; /* red */
  --color-warning:             #FBCB21; /* yellow */

/* Gradients */
  --gradient-line:             linear-gradient(90deg, var(--color-brand-2nd) 0%, var(--color-brand-1st) 100%);
  --gradient-background-1:     linear-gradient(-50deg, var(--color-brand-2nd) 0%, var(--color-brand-1st) 100%);
  --gradient-background-2:     linear-gradient(50deg, var(--color-brand-2nd) 0%, var(--color-brand-1st) 100%);
  --gradient-overlay-1:        linear-gradient(-60deg, rgba(22,0,43,0.38) 0%, var(--color-brand-3rd) 100%);
  --gradient-overlay-2:        linear-gradient(60deg, rgba(22,0,43,0.38) 0%, var(--color-brand-3rd) 100%);
  --gradient-white:            linear-gradient(180deg, rgba(255,255,255,.4) 0%, rgba(255,255,255,.3) 60%, rgba(255,255,255,0) 100%);

/* Shadows */
  --box-shadow-medium:             0 0 2.5rem 0 rgba(22,0,43,0.15); /* --color-default*/
  --box-shadow-medium-blue:        0 0 2.5rem 0 rgba(51,154,250,0.15); /* --color-brand-2nd */
  --box-shadow-main-large:         0 0 8rem 0 rgba(22,0,43,0.13);
  --box-shadow-main-large-blue:    0 0 4rem 0 rgba(51,154,250,0.1);

/* Gutters */
  --gutter-xxs: .5rem;
  --gutter-xs: 1rem;
  --gutter-sm: 2rem;
  --gutter-md: 2.8rem;
  --gutter-lg: 5.6rem;
  --gutter-xl: 8.4rem;
}
*,
*:after,
*:before {
    box-sizing: border-box;
}
html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    background: var(--color-default-background);
    color: var(--color-default);
    font-family: var(--font-family);
    font-size: 62.5%;
    font-weight: 400;
    height: 100%;
    overflow-x: hidden;
    position: relative;
    text-rendering: auto;
    width: 100%;
}
body {
    background: var(--gradient-line);
    display: flex;
    flex-direction: column;
    font-size: var(--font-size-sm);
    min-height: 100vh;
    line-height: var(--line-height-xs);
    margin: 0;
    padding: 0;
    width: 100%;
}
body::before {
  background: rgba(0,0,0,.15);
  content: '';
  display: block;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
header {
  align-items: center;
  display: flex;
  position: relative;
  z-index: 25;
}
header h1,
header input {
  flex: 1;
  margin: 0;
}
header input {
  background-color: rgba(255,255,255,1);
  flex: 0 0 calc(23.5rem + var(--gutter-md));
  margin: 0 5.5rem 0 0;
}
#app {
  padding: var(--gutter-sm) var(--gutter-md) var(--gutter-md);
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
}
/* Headings */
h1, .h1 {
  font-size: 3rem;
  line-height: 1.6;
  font-weight: 800;
  margin: 0 0 var(--gutter-xs);
}
h1 strong {
  font-weight: 800;
  color: var(--color-default);
}
h2, .h2 {
  font-size: 3rem;
  line-height: 1.6;
  font-weight: 800;
  margin: 0 0 var(--gutter-xs);
}
h3, .h3 {
  font-size: 2.5rem;
  line-height: 1.6;
  font-weight: 800;
  margin: 0 0 var(--gutter-xs);
}
h4, .h4 {
  font-size: 2rem;
  line-height: 1.6;
  font-weight: 500;
  margin: 0 0 var(--gutter-xs);
}
h5, .h5 {
  color: rgba(255,255,255,.6);
  font-weight: 500;
  margin: 0 0 var(--gutter-xs);
}
@media only screen and (min-width: 1024px) {
  h1, .h1 {
  font-size: 8rem;
}
  h2, .h2 {
    font-size: 4rem;
  }
  h3, .h3 {
    font-size: 3rem;
  }
  h4, .h4 {
    font-size: 2.5rem;
  }
  h5, .h5 {
    font-size: 1.8rem;
    font-weight: 800;
  }
}
/* Lists */
ul[class] {
  list-style: none;
  margin: 0;
  padding: 0;
}

table {
  display: block;
  border-spacing: 0;
  max-height: calc(100vh - 28rem);
  overflow: auto;
  position: relative;
  width: 100%;
}
table::before {
  background: var(--gradient-background-1);
  box-shadow: 0 0 1rem 0 rgba(0,0,0,.1);
  content: '';
  height: 100%;
  left: 0;
  opacity: .9;
  position: fixed;
  top: 0;
  width: calc(29rem + var(--gutter-md));
  z-index: 19;
}
table::-webkit-scrollbar {
  width: .4rem;
  height: .4rem;
}

table::-webkit-scrollbar-track {
  background-color: rgba(0,0,0,.1);
  border-radius: .2rem;
}
table::-webkit-scrollbar-corner {
   background-color: rgba(0,0,0,.1);
}
table::-webkit-scrollbar-thumb {
  border-radius: .2rem;
  background-image: var(--gradient-background-2);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
}
tr {
  align-items: center;
  display: flex;
  width: 100%;
}
td, th {
  align-items: center;
  border-radius: .6rem;
  display: flex;
  height: calc(4rem + var(--gutter-xs) + var(--gutter-xs));
  flex: 1 0 15rem;
  margin: .2rem;
}

td > div {
    padding: var(--gutter-xs);
}
tbody tr:nth-child(odd) tds {}
tbody tr:nth-child(even) td {}
tbody th {
  border-bottom: solid .1rem rgba(255,255,255,.1);
  text-align: left;
}
tbody td.monday {
  background-color: rgba(255,255,255,.2);
}
tbody td.today {
  background-color: rgba(255,255,255,.2);
}
tbody td.not-today {
  border: solid .1rem rgba(255,255,255,.3);
}
tbody th {
  left: 0;
  padding-left: var(--gutter-xs);
  position: sticky;
  top: auto;
  z-index: 20;
}
thead td:first-child,
thead th:first-child,
tfoot td:first-child,
tfoot th:first-child {
  background: none;
  border: none;
}
td:first-child, th:first-child {
  flex: 0 0 31rem;
  max-width: none;
}
thead {
  left: auto;
  position: sticky;
  top: 0;
  z-index: 15;
}

thead th,
tfoot th {
  background: rgba(255,255,255,.9);
  border-radius: 0;
  color: var(--color-brand-3rd);
  margin: 0 .2rem;
}
thead th {
  margin-bottom: .5rem;
}
tfoot th {
  margin-top: .5rem;
}
thead .monday,
tfoot .monday {
  background: var(--color-brand-1st);
  color: var(--color-brand-3rd);
}
thead .today,
tfoot .today {
  color: var(--color-brand-1st);
  background: var(--color-brand-3rd);
}

/* Form elements */
label {
  font-weight: 500;
  font-size: var(--font-size-xs);
}
input {
  background-color: rgba(255,255,255,.2);
  border: .1rem solid rgba(22,0,43,.1);
  color: var(--color-default);
  display: block;
  font-size: var(--font-size-xs);
  font-weight: 400;
  line-height: 1.6;
  outline: none;
  padding: var(--gutter-xs) var(--gutter-sm);
  transition: all 450ms cubic-bezier(0.215, 0.61, 0.355, 1), color 100ms cubic-bezier(0.215, 0.61, 0.355, 1) 100ms;
  width: 100%;
}
input:active,
input:focus {
  background-color: rgba(255,255,255,.7);
  border-color: var(--color-brand-2nd);
  transition: all 450ms cubic-bezier(0.215, 0.61, 0.355, 1), color 100ms cubic-bezier(0.215, 0.61, 0.355, 1) 100ms;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: var(--color-default);
  opacity: .3;
}
::-moz-placeholder { /* Firefox 19+ */
  color: var(--color-default);
  opacity: .3;
}
:-ms-input-placeholder { /* IE 10+ */
  color: var(--color-default);
  opacity: .3;
}
:-moz-placeholder { /* Firefox 18- */
  color: var(--color-default);
  opacity: .3;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    background: rgba(0,0,0,.1);
    border-radius: var(--gutter-md);
    box-shadow: inset 0 0 .5rem rgba(0,0,0,.2);
    height: var(--gutter-md);
    outline: none;
    margin: .9rem 0;
    position: relative;
    transition: .7s;
    width: calc(var(--gutter-md) * 2);
}

input:checked[type="checkbox"] {
  background: var(--color-brand-1st);
}
input:checked[type="checkbox"]::before {
  left: var(--gutter-md);
}

input[type="checkbox"]:before {
  background: #fff;
  border-radius: 100%;
  box-shadow: 0 .2rem .5rem rgba(0,0,0,.2);
  content: '';
  height: var(--gutter-md);
  left: 0;
  position: absolute;
  top: 0;
  transform: scale(1.2);
  transition: .5s;
  width: var(--gutter-md);
}

button:not(.button__reset) {
  background-image:linear-gradient(42deg,var(--color-brand-2nd),var(--color-brand-2nd) 32%,rgba(0,0,0,0) 0,rgba(0,0,0,0));
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 600%;
  border: solid 1px var(--color-brand-2nd);
  color: var(--color-brand-2nd);
  cursor:pointer;
  display: inline-block;
  font-size: var(--font-size-xs);
  font-weight: 500;
  line-height: 1.6;
  min-height: 4.6rem;
  min-width: 4.6rem;
  padding: var(--gutter-xs) var(--gutter-sm);
  text-decoration: none;
  transition: background 450ms cubic-bezier(0.215, 0.61, 0.355, 1), color 100ms cubic-bezier(0.215, 0.61, 0.355, 1) 100ms;
}
button:hover {
  background-position: 0%;
  color: #fff;
}
button.invert {
  background-position: 0%;
  color: #fff;
}
button.invert:hover {
  background-position: 50%;
  color: var(--color-brand-2nd);
}
button.invert .icon {
  fill: #fff;
}
button.invert:hover .icon{
  fill: var(--color-brand-2nd);
}
button:hover .icon {
  fill: #fff;
}
.button__reset {
  background: none;
  border: none;
  padding: 0;
}
/* Specifics */
.icon {
    height: var(--gutter-sm);
    width: var(--gutter-sm);
}
.tag {
  align-items: center;
  border-radius: .6rem;
  border-width: .1rem .1rem 0;
  display: flex;
  font-size: var(--font-size-xs);
  height: 100%;
  justify-content: center;
  padding: var(--gutter-sm) var(--gutter-xs);
  width: calc(100% + .2rem);
}

.legenda {
  align-items: center;
  display: flex;
  margin: 4rem 0 0 32rem!important;
}
.legenda li {
  font-size: 1.4rem;
  margin: 0 2rem 0 0;
  padding-left: 2rem;
}
.legenda .icon {
  width: auto;
  height: auto;
  background-size: 1.5rem 1.5rem;
  background-repeat: no-repeat;
  background-position: left bottom .9rem;
}
.legenda .icon.icon-extern {
  height: auto;
  width: auto;
  margin-top: 0;
}

.legenda .icon.icon-servicedesk {
  background-size: 1.5rem 2rem;
  background-position: left bottom .7rem;
}

.icon.icon-home {
  background-image: url(assets/emoji.svg#home-icon);
}
.icon.icon-free {
  background-image: url(assets/emoji.svg#bicycle-icon);
}
.icon.icon-rosterfree {
  background-image: url(assets/emoji.svg#rosterfree-icon);
}
.icon.icon-holiday {
  background-image: url(assets/emoji.svg#holiday-icon);
}
.icon.icon-servicedesk {
  background-image: url(assets/emoji.svg#servicedesk-icon);
  background-size: 3.2rem;
}
.icon.icon-office {
  background-image: url(assets/emoji.svg#office-icon);
}
.icon.icon-open {
  background-image: url(assets/emoji.svg#open-icon);
}

.icon.icon-skyscraper {
  background-image: url(assets/emoji.svg#skyscraper-icon);
}
.icon.icon-extern {
  background-image: url(assets/emoji.svg#extern-icon);
  height: 4rem;
  margin-top: -.25rem;
  width: 4.5rem;
}
.loading {
  background-image: url(assets/sprite.svg#loader-icon);
  background-size: 2rem 2rem;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: .8;
}
/* Transitions */
.fade-enter-active, .fade-leave-active {
  opacity: 0;
  transition: opacity 330ms ease-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transition: opacity 130ms ease-in;
}
/* slide transition */
.slide-leave-active,
.slide-enter-active {
  transform: translate(100%, 0);
  transition: transform 130ms ease-in;
}
.slide-enter {
  transition: transform 330ms ease-in;
}
.slide-leave-to {
  transform: translate(100%, 0);
}
.slideback-leave-active,
.slideback-enter-active {
  transition: transform 130ms ease-in;
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 800;
	src:url(./assets/fonts/cerapro/cerapro_black_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_black_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_black_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_black_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_black_italic.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 700;
	src:url(./assets/fonts/cerapro/cerapro_bold_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_bold_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_bold_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_bold_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_bold_italic.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 300;
	src:url(./assets/fonts/cerapro/cerapro_light_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_light_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_light_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_light_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_light_italic.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 800;
	src:url(./assets/fonts/cerapro/cerapro_black.eot);
	src:url(./assets/fonts/cerapro/cerapro_black.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_black.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_black.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_black.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 300;
	src:url(./assets/fonts/cerapro/cerapro_light.eot);
	src:url(./assets/fonts/cerapro/cerapro_light.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_light.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_light.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_light.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 700;
	src:url(./assets/fonts/cerapro/cerapro_bold.eot);
	src:url(./assets/fonts/cerapro/cerapro_bold.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_bold.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_bold.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_bold.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 500;
	src:url(./assets/fonts/cerapro/cerapro_medium.eot);
	src:url(./assets/fonts/cerapro/cerapro_medium.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_medium.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_medium.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_medium.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 500;
	src:url(./assets/fonts/cerapro/cerapro_medium_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_medium_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_medium_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_medium_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_medium_italic.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 400;
	src:url(./assets/fonts/cerapro/cerapro_regular_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_regular_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_regular_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_regular_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_regular_italic.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 400;
	src:url(./assets/fonts/cerapro/cerapro_regular.eot);
	src:url(./assets/fonts/cerapro/cerapro_regular.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_regular.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_regular.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_regular.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: normal;
	font-weight: 200;
	src:url(./assets/fonts/cerapro/cerapro_thin.eot);
	src:url(./assets/fonts/cerapro/cerapro_thin.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_thin.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_thin.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_thin.ttf") format("truetype");
}

@font-face {
	font-family:'CeraPRO';
	font-style: italic;
	font-weight: 200;
	src:url(./assets/fonts/cerapro/cerapro_thin_italic.eot);
	src:url(./assets/fonts/cerapro/cerapro_thin_italic.eot?#iefix) format("embedded-opentype"),url("./assets/fonts/cerapro/cerapro_thin_italic.woff2") format("woff2"),url("./assets/fonts/cerapro/cerapro_thin_italic.woff") format("woff"),url("./assets/fonts/cerapro/cerapro_thin_italic.ttf") format("truetype");
}
</style>
